import React, { useEffect, useState } from "react";
import {
  ACTIONARROW_ICON,
  EDIT_ICON,
  RIGHTARROW_ICON,
} from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import { ROUTES } from "../../routes/url-constant";
import { useNavigate } from "react-router-dom";
import {
  CompanyactiveInactive,
  getAdminBlock,
  getAllactiveInactiveCompany,
  getallAdmin,
  getAllCompany,
} from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";
import moment from "moment";
import EmployeeBulkUpload from "./EmployeeBulkUpload";

const CompanyManagement = () => {
  const [pending, setPending] = useState(false);

  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [permissionAccess, setPermissionAccess] = useState();
  const [totalElement, settotalElement] = useState();
  const { value } = useSelector((state) => state?.adminRole);
  useEffect(() => {
    const RoleAccessFilterData =
      value && value?.filter((v) => v.moduleName === "Customer Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, [value]);
  const payload = {
    pageIndex: page,
    pageSize: pageSize,
    searchText: searchText,
    direction: sortDirection,
    filterByFieldName: sortColumn,
  };
  const getallCompany = async () => {
    setPending(true);
    try {
      const response = await getAllCompany(payload);
      if (response?.data?.responseCode === 404) {
        setRowData([]);
        setPending(false);
      } else if (response?.data?.responseCode === 200) {
        setRowData(response?.data?.responseBody?.companyResponsePayloadList);
        settotalElement(response?.data?.responseBody?.totalElement);
        setPending(false);
      } else {
        toastEmitter("error", response?.data?.message);
        setPending(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setPending(false);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallCompany();
  }, [page, pageSize, searchText, sortColumn, sortDirection]);

  const handleStatusChange = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle the status

    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update local state with the new status

    try {
      let response = await CompanyactiveInactive(row.id, newStatus);

      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else {
        // If the API fails, revert the status in local state
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
        console.error("Failed to update model status");
      }
    } catch (error) {
      // If there's an error, revert the status in local state
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
      console.error("Error during status change:", error);
    }
  };

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
        overflowX: "auto",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
        overflowX: "auto",
      },
    },
  };

  const tblColumns = [
    {
      code: "Action",
      name: "Action",
      width: "130px",
      sortable: false,
      cell: (row) => (
        <div className="">
          <button className="border-0 bg-white">
            {/* {permissionAccess?.updateAction === 1 && ( */}
            <img
              src={EDIT_ICON}
              alt="Edit"
              className="editicon"
              onClick={() =>
                navigate(ROUTES?.ADDCOMPANY, {
                  state: { pageType: "Edit", Data: row },
                })
              }
            />
            {/* )} */}

            <span>
              <button className="border-0 bg-white" onClick={() => navigate(ROUTES.ADDCOMPANY, { state: { pageType: "view", Data: row } })}>
                <img src={ACTIONARROW_ICON} alt="View" className="editicon ms-2" />
              </button>
            </span>
          </button>
        </div>
      ),
    },
    {
      code: "companyName",
      name: "Company Name",
      width: "210px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.companyName}</div>
      ),
    },
    {
      code: "email",
      name: "Email",
      width: "320px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.email}</div>
      ),
    },
    
    {
      code: "status",
      name: "Status",
      width: "180px",
      omit: false,
      sortable: true,
      cell: (row) => (
        <div className="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row?.status === 1}
              onChange={() => handleStatusChange(row)}
            />
            <div className="slider round">
              {row?.status === 1 ? (
                <span className="on">Active</span>
              ) : (
                <span className="off">Inactive</span>
              )}
            </div>
          </label>
        </div>
      ),
    },

  ];

  const handleModelSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const navigate = useNavigate();
  const addButtonClick = () => {
    navigate(ROUTES.ADDCOMPANY);
  };

  return (
    <>
      {permissionAccess?.addAction == 0 &&
        permissionAccess?.updateAction == 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="modal_datatable">
            <TableHeading firstData="Customer Management" icon={RIGHTARROW_ICON} secondData="Company Management" />

            <div className="container-fluid">
              <div className="caspera_admin_datatable mb-3">
                <SearchAndAddItem
                  // title="Company List"
                  searchValue={searchText}
                  onSearchChange={handleModelSearchChange}
                  addButtonClick={addButtonClick}
                  data="Company"
                  permissionAccessbtn={permissionAccess?.addAction}
                />
                {/* {pending ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                  </div>
                ) : ( */}
                <AdminDataTable
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  tableCustomStyles={tableCustomStyles}
                  pending={pending}
                  setPending={setPending}
                  _totalRows={totalElement}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />
                {/* )} */}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CompanyManagement;
